export function mod(multiplier: number, unit?: string): string {
  return unit === 'rem' ? `${multiplier / 2}rem` : `${multiplier * 8}px`;
}
